//权限列
enum Role {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN', //系统管理员
  ADMIN = 'ADMIN', //管理员
  OPERATIONS_ONE = 'OPERATIONS_ONE', //运营人员一级
  OPERATIONS_TWO = 'OPERATIONS_TWO', //运营人员二级
  VISITOR = 'VISITOR', //观察员
}
class AuthParams {
  name: string = ''
  type: string = ''
}

const authority: any = {
  workbench: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN],
    visitor: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  contract: {
    view: [Role.SYSTEM_ADMIN, Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN, Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.SYSTEM_ADMIN]
  },
  cabinetManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    delete: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  pickupManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  stockManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    delete: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  replenishManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  inventoryManagement: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  pointManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  pointTypeManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  lineManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  order: {//货柜订单
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  cooperation: {//货柜订单
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  joint: { //联合查询
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  openRecord: { //开门记录表
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      // Role.VISITOR
    ],
  },
  interfaceUsage: { //接口使用列表
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      // Role.VISITOR
    ],
  },
  goodsStatistics:{//商品统计
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
  },
  goodsDailysales:{//每日销售额
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
  },
  pushMangement:{//商品统计
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
  },
  loginMangement:{//商品统计
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
  },
  openStatistics:{
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],

  },

  shopOrder: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  shopCategory: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.SYSTEM_ADMIN
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN]
  },
  shopManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.SYSTEM_ADMIN
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN]
  },
  shopModel: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
    shopModels: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN,Role.OPERATIONS_ONE,Role.OPERATIONS_TWO],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN,Role.OPERATIONS_ONE,Role.OPERATIONS_TWO],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN,Role.OPERATIONS_ONE,Role.OPERATIONS_TWO]
  },
  activetyManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN],
    updown: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  qrcodeManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  balanceList: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      // Role.VISITOR
    ],
  },
  dimensionList: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      // Role.VISITOR
    ],
  },
  // finance: {
  //   view: [Role.ADMIN, Role.VISITOR],
  //   add: [Role.ADMIN, Role.VISITOR],
  //   delete: [Role.ADMIN, Role.VISITOR]
  // },
    finance: {
    view: [Role.ADMIN],
    add: [Role.ADMIN],
    delete: [Role.ADMIN]
  },
  tradeDetail: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.VISITOR],
    select: [Role.SYSTEM_ADMIN],
    areaSelect: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  userList: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
  },
  systemUser: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN, Role.SYSTEM_ADMIN],
    discab: [Role.SYSTEM_ADMIN] //分配柜子
  },
  replenishmenter: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  memberManage: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  suggestion: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    delete: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  reportFailure: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    delete: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ],
    update: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  DA: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  statistical: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  log: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.SYSTEM_ADMIN
    ]
  },
  document: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  financeAudit: {
    view: [Role.SYSTEM_ADMIN]
  },
  discount: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ],
    add: [Role.SYSTEM_ADMIN, Role.ADMIN],
    update: [Role.SYSTEM_ADMIN, Role.ADMIN],
    delete: [Role.SYSTEM_ADMIN, Role.ADMIN],
    updown: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO
    ]
  },
  splitBill: {
    view: [Role.SYSTEM_ADMIN]
  },
  systemSetting: {
    view: [Role.SYSTEM_ADMIN, Role.ADMIN]
  },
  goodsRecognitionRate: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  goodsGroup: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  inspection: {
    view: [
      Role.SYSTEM_ADMIN,
      Role.ADMIN,
      Role.OPERATIONS_ONE,
      Role.OPERATIONS_TWO,
      Role.VISITOR
    ]
  },
  mengniubench: {
    view: [Role.SYSTEM_ADMIN]
  },
  mengniuInspection: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuArea: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuRegion: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuPoint: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuInventorydetails: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuGoods: {
    view: [Role.SYSTEM_ADMIN],
    add: [Role.SYSTEM_ADMIN],
    delete: [Role.SYSTEM_ADMIN],
    update: [Role.SYSTEM_ADMIN]
  },
  mengniuInspectionDA: {
    view: [Role.SYSTEM_ADMIN]
  },
  mengniuSales: {
    view: [Role.SYSTEM_ADMIN]
  },
  advertisement: {
    view: [Role.SYSTEM_ADMIN]
  },
  applyAd: {
    view: [Role.ADMIN]
  },
  advertisingdelivery: {
    view: [Role.SYSTEM_ADMIN]
  },
  examine: {
    view: [Role.SYSTEM_ADMIN]
  }
}

export default {
  state: {
    role: ''
  },
  getters: {
    authority: (state: any) => (parmas: AuthParams) => {
      const result: boolean =
        authority[parmas.name][parmas.type].indexOf(state.role) > -1
      return result
    }
  },
  mutations: {
    setRole(state: any, data: any) {
      state.role = data.role
    }
  }
}
